const Members = () => {
	// fetch list of  pandits and render here
	return <div>Members</div>;
};

export default Members;
